/**
 * Featured Categories Horizontal Scroll
 * Permette lo scroll orizzontale con il mouse (tasto sinistro premuto + scroll)
 */

function initHorizontalScroll() {
    const featuredCategoriesLists = document.querySelectorAll('.featured_categories_list:not(.horizontal-scrollable)');

    featuredCategoriesLists.forEach((list, index) => {
        let isMouseDown = false;
        let startX = 0;
        let scrollLeft = 0;

        // Crea le frecce di navigazione
        const prevArrow = document.createElement('button');
        prevArrow.className = 'horizontal-scroll-arrow horizontal-scroll-arrow-prev';
        prevArrow.setAttribute('aria-label', 'Scroll precedente');
        prevArrow.innerHTML = '<i class="fto-left-open-3"></i>';

        const nextArrow = document.createElement('button');
        nextArrow.className = 'horizontal-scroll-arrow horizontal-scroll-arrow-next';
        nextArrow.setAttribute('aria-label', 'Scroll successivo');
        nextArrow.innerHTML = '<i class="fto-right-open-3"></i>';

        // Aggiungi le frecce al container (se non esistono già)
        if (!list.parentElement.querySelector('.horizontal-scroll-arrow-prev')) {
            list.parentElement.style.position = 'relative';
            list.parentElement.appendChild(prevArrow);
            list.parentElement.appendChild(nextArrow);
        }

        // Funzione per aggiornare la visibilità delle frecce
        function updateArrows() {
            const canScrollLeft = list.scrollLeft > 0;
            const canScrollRight = list.scrollLeft < (list.scrollWidth - list.clientWidth - 1); // -1 per tolleranza

            prevArrow.classList.toggle('visible', canScrollLeft);
            prevArrow.classList.toggle('disabled', !canScrollLeft);
            nextArrow.classList.toggle('visible', canScrollRight);
            nextArrow.classList.toggle('disabled', !canScrollRight);
        }

        // Funzione helper per calcolare la quantità di scroll
        function getScrollAmount() {
            const isMobile = window.innerWidth <= 768; // Breakpoint mobile
            if (isMobile) {
                // Su mobile, scrolla di esattamente una slide
                const firstItem = list.querySelector('.featured_categories_item');
                if (firstItem) {
                    // Include gap e padding se presenti
                    const itemWidth = firstItem.offsetWidth;
                    const gap = parseInt(getComputedStyle(list).gap) || 0;
                    return itemWidth + gap;
                }
            }
            // Su desktop, scrolla dell'80% della larghezza visibile
            return list.clientWidth * 0.8;
        }

        // Gestisce il click sulle frecce
        prevArrow.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const scrollAmount = getScrollAmount();
            list.scrollBy({
                left: -scrollAmount,
                behavior: 'smooth'
            });
        });

        nextArrow.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const scrollAmount = getScrollAmount();
            list.scrollBy({
                left: scrollAmount,
                behavior: 'smooth'
            });
        });

        // Gestisce il mousedown
        list.addEventListener('mousedown', (e) => {
            isMouseDown = true;
            list.style.cursor = 'grabbing';
            startX = e.pageX - list.offsetLeft;
            scrollLeft = list.scrollLeft;
            e.preventDefault();
        });

        // Gestisce il mouseleave
        list.addEventListener('mouseleave', () => {
            isMouseDown = false;
            list.style.cursor = 'grab';
        });

        // Gestisce il mouseup
        list.addEventListener('mouseup', () => {
            isMouseDown = false;
            list.style.cursor = 'grab';
        });

        // Gestisce il mousemove
        list.addEventListener('mousemove', (e) => {
            if (!isMouseDown) return;
            e.preventDefault();
            const x = e.pageX - list.offsetLeft;
            const walk = (x - startX) * 2; // Moltiplica per velocità
            list.scrollLeft = scrollLeft - walk;
        });

        // Gestisce lo scroll con la rotella del mouse
        list.addEventListener('wheel', (e) => {
            // Controlla se il tasto sinistro è premuto
            if (e.buttons === 1) {
                e.preventDefault();
                list.scrollLeft += e.deltaY;
            }
        });

        // Aggiorna le frecce quando si scrolla
        list.addEventListener('scroll', updateArrows);

        // Aggiorna le frecce quando la finestra viene ridimensionata
        const resizeObserver = new ResizeObserver(() => {
            updateArrows();
        });
        resizeObserver.observe(list);

        // Imposta il cursore iniziale
        list.style.cursor = 'grab';

        // Aggiunge la classe per indicare che è scrollabile
        list.classList.add('horizontal-scrollable');

        // Aggiorna le frecce all'inizializzazione
        setTimeout(updateArrows, 100);
    });
}

// Inizializza subito se il DOM è già pronto
document.addEventListener('DOMContentLoaded', initHorizontalScroll);

// Inizializza anche se il DOM è già caricato (per componenti dinamici)
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHorizontalScroll);
} else {
    initHorizontalScroll();
}

// Observer per monitorare l'aggiunta di nuovi elementi
const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
        if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === 1) { // Element node
                    // Controlla se il nodo aggiunto contiene o è una lista di categorie
                    if (node.classList && node.classList.contains('featured_categories_list')) {
                        initHorizontalScroll();
                    } else if (node.querySelector && node.querySelector('.featured_categories_list')) {
                        initHorizontalScroll();
                    }
                }
            });
        }
    });
});

// Avvia l'osservazione
observer.observe(document.body, {
    childList: true,
    subtree: true
});
